export interface IQuestion {
    key?: string,
    created?: string,
    createdby?: string,
    modified?: string,
    modifiedBy?: string,
    title: string,
    description: string,
    titleEn?: string,
    descriptionEn?: string,
    creatorId?: string,
    creatorUpn?: string,
    creatorDisplayName?: string,
    country?: string,
    isAnonymous?: boolean,
    anonymousQuestionsEnabled?: boolean,
    votes?: number,
    state?: IQuestionState,
    answer?: IAnswer,
    canEdit?: boolean,
    canDelete?: boolean,
    canAnswer?: boolean,
    canVote?: boolean
}

export interface IQuestionOptions {
    creatorDisplayName: string,
    country: string,
    anonymousQuestionsEnabled: boolean
}

export interface INotificationSettings {
    language: string,
    notifyNewQuestions: boolean,
    notifyAnsweredQuestions: boolean
}

export enum IQuestionState {
    Pending = 0,
    Answered = 1
}

export interface IAnswer {
    answeredById?: string,
    answeredByDisplayName?: string,
    url?: string,
    answerDate?: string
}
